import { useAccountID } from "../store/account";
import { useShow, useShowID } from "../store/show";

export function DownloadsLabel({ showID } = {}) {
    const { data: show } = useShow(useAccountID(), showID || useShowID()) || {};
    return !show ? "" : show.youTubeShow ? "Views" : "Downloads";
}
